<div class="container-fluid p-0">
  <sa-nav></sa-nav>
  <router-outlet></router-outlet>

</div>

<sa-toasts aria-live="polite" aria-atomic="true"></sa-toasts>

